import React, { useState } from 'react';
import { FiX, FiDollarSign } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-toastify';
import { paymentService } from '../services/api';
import '../styles/DonationSidebar.css';

const DonationSidebar = ({ isOpen, onClose }) => {
    const [selectedAmount, setSelectedAmount] = useState(5);
    const [customAmount, setCustomAmount] = useState('');
    const [loading, setLoading] = useState(false);

    const predefinedAmounts = [
        { value: 5, coffees: 1 },
        { value: 15, coffees: 3 },
        { value: 25, coffees: 5 }
    ];

    const handleCustomAmountChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value) || value === '') {
            setCustomAmount(value);
            const floatValue = parseFloat(value);
            if (!isNaN(floatValue)) {
                setSelectedAmount(floatValue);
            }
        }
    };

    const handleAmountSelect = (amount) => {
        setSelectedAmount(amount);
        setCustomAmount('');
    };

    const handlePayment = async () => {
        if (selectedAmount <= 0) {
            toast.error('Please enter a valid amount');
            return;
        }

        setLoading(true);
        try {
            const { data: order } = await paymentService.createOrder(selectedAmount);

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: order.amount,
                currency: order.currency,
                name: "Quick Inbox",
                description: "Support Quick Inbox Development",
                order_id: order.id,
                handler: function (response) {
                    toast.success('Thank you for your support!');
                    onClose();
                },
                prefill: {
                    name: "",
                    email: "",
                },
                modal: {
                    ondismiss: function() {
                        toast.info('Payment cancelled');
                    }
                },
                theme: {
                    color: "#3399cc"
                }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error('Payment error:', error);
            toast.error('Payment failed. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        className="donation-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.5 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                    />
                    <motion.div
                        className="donation-sidebar"
                        initial={{ x: '100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '100%' }}
                        transition={{ type: 'tween' }}
                    >
                        <div className="donation-header">
                            <h3>Support My Work</h3>
                            <button className="close-button" onClick={onClose}>
                                <FiX />
                            </button>
                        </div>

                        <div className="donation-content">
                            <div className="amount-options">
                                {predefinedAmounts.map(({ value, coffees }) => (
                                    <button
                                        key={value}
                                        className={`amount-option ${selectedAmount === value ? 'selected' : ''}`}
                                        onClick={() => handleAmountSelect(value)}
                                    >
                                        <span className="amount">${value}</span>
                                        <span className="coffees">
                                            {Array(coffees).fill('☕').join(' ')}
                                        </span>
                                    </button>
                                ))}
                            </div>

                            <div className="custom-amount">
                                <label>Custom Amount</label>
                                <div className="custom-amount-input">
                                    <FiDollarSign />
                                    <input
                                        type="text"
                                        value={customAmount}
                                        onChange={handleCustomAmountChange}
                                        placeholder="Enter amount"
                                        inputMode="decimal"
                                    />
                                </div>
                            </div>

                            <div className="donation-message">
                                <p>Your support helps me continue creating and maintaining this project.</p>
                                <p className="selected-amount">Selected amount: ${selectedAmount.toFixed(2)}</p>
                            </div>

                            <button 
                                className="payment-button" 
                                onClick={handlePayment}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="loading-spinner"></span>
                                        Processing...
                                    </>
                                ) : (
                                    <>
                                        <FiDollarSign />
                                        Proceed to Payment
                                    </>
                                )}
                            </button>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default DonationSidebar; 